import { useEffect, useState } from 'react';
import { thumbnailSrc } from '../api/media';
import type { StagedKind } from '../components/AttachPreviewModal';

export function classifyFile(file: File): StagedKind {
  if (file.type.startsWith('image/')) return 'image';
  if (file.type.startsWith('video/')) return 'video';
  if (file.type.startsWith('audio/')) return 'audio';
  return 'file';
}

/** Постер видео (кадр) через /thumbnail + флаг "попытка завершена" (для видео кадра может не
 *  быть — старое видео до фичи превью или ffmpeg недоступен, /thumbnail отвечает 404). */
export function useVideoPoster(fileId?: string): { poster: string | null; loaded: boolean } {
  const [poster, setPoster] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setPoster(null);
    setLoaded(false);
    if (!fileId) return;
    // thumbnailSrc кэширует blob-URL по fileId на весь срок жизни вкладки (см. api/media.ts) —
    // URL общий для всех виджетов этого fileId, поэтому здесь его больше НЕ ревокаем.
    let alive = true;
    thumbnailSrc(fileId)
      .then((u) => {
        if (alive) setPoster(u);
      })
      .catch(() => {})
      .finally(() => alive && setLoaded(true));
    return () => {
      alive = false;
    };
  }, [fileId]);
  return { poster, loaded };
}

/** Круглое видео-сообщение — это запись через кнопку записи (без fileName в media),
 *  а не обычный прикреплённый видеофайл (у того fileName всегда есть). */
export function isRoundVideoMsg(msg: { payload: { data?: { media?: { kind?: string; fileName?: string | null }[] | null } | null } }): boolean {
  const mediaList = msg.payload.data?.media ?? [];
  return mediaList.length === 1 && mediaList[0].kind === 'video' && !mediaList[0].fileName;
}
